export default __webpack_public_path__ + "static/media/ConveyorMerger.64.2102b310.png";